import { router } from 'expo-router';
import {
    Animations,
    FootnoteRegular,
    H2Emphasized,
    H6Regular,
    Image,
    Shadows,
    View,
    YStack,
} from 'smoothie';

import BookGeneralSession from '../../../assets/images/guidance_sessions/book_general_session.png';
import { useViewEvents } from '../../events/hooks/useViewEvents';
import { GuidanceSessionType } from '../types/GuidanceSessions';

const BookGeneralGuidanceWidget = () => {
    const { trackViewOnce } = useViewEvents();
    trackViewOnce('BookGeneralGuidanceWidget');

    return (
        <YStack $sm={{ flex: 1 }} {...Animations.FadeIn}>
            <H6Regular marginBottom={12}>Sessions</H6Regular>
            <View
                backgroundColor="$peach300"
                borderRadius={20}
                paddingHorizontal={22}
                paddingVertical={22}
                {...Shadows.SMALL}
                cursor="pointer"
                onPress={() => {
                    router.navigate({
                        pathname: '/guidance-sessions/book-session',
                        params: {
                            sessionType: GuidanceSessionType.QUICK_CHECK_IN,
                        },
                    });
                }}
            >
                <Image
                    source={BookGeneralSession}
                    width={106}
                    height={88}
                    alignSelf="flex-end"
                    $sm={{
                        // @ts-expect-error - Tamagui is missing some web props in the types
                        order: 2,
                    }}
                />
                <H2Emphasized maxWidth={262} marginBottom={6}>
                    Book a session
                </H2Emphasized>
                <FootnoteRegular maxWidth={218} color="$gray1100">
                    Keep on top of all your progress, tasks and goals.
                </FootnoteRegular>
            </View>
        </YStack>
    );
};

export default BookGeneralGuidanceWidget;
